/* NERDIS · Pandilla — lo mínimo. Todo funciona sin JS; esto solo lo hace más cómodo. */
(function () {
  'use strict';

  /* Menú móvil: <dialog> nativo, con cierre por Escape y por fondo. */
  var menu = document.getElementById('p-menu');
  var abrir = document.querySelector('[data-p-menu-abrir]');
  if (menu && abrir && typeof menu.showModal === 'function') {
    abrir.addEventListener('click', function (e) {
      e.preventDefault();
      menu.showModal();
      var primero = menu.querySelector('input, a, button');
      if (primero) { primero.focus(); }
    });
    menu.querySelectorAll('[data-p-menu-cerrar]').forEach(function (b) {
      b.addEventListener('click', function () { menu.close(); });
    });
    menu.addEventListener('click', function (e) {
      var r = menu.getBoundingClientRect();
      if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) { menu.close(); }
    });
    menu.addEventListener('close', function () { abrir.focus(); });
  }

  /* Ficha: la talla elegida viaja al personalizador (?v=) y al formulario. */
  var tallas = document.querySelectorAll('[data-p-talla]');
  var enlace = document.querySelector('[data-p-disenar]');
  var oculto = document.querySelector('[data-p-variante]');
  function tallaElegida() {
    var m = null;
    tallas.forEach(function (t) { if (t.checked) { m = t; } });
    return m;
  }
  function alCambiarTalla() {
    var t = tallaElegida();
    if (oculto && t) { oculto.value = t.value; }
    if (enlace) {
      var u = new URL(enlace.getAttribute('href'), location.origin);
      if (t) { u.searchParams.set('v', t.value); } else { u.searchParams.delete('v'); }
      enlace.setAttribute('href', u.pathname + u.search);
    }
    var aviso = document.querySelector('[data-p-aviso-talla]');
    if (aviso && t) { aviso.hidden = true; }
  }
  tallas.forEach(function (t) { t.addEventListener('change', alCambiarTalla); });
  if (tallas.length) { alCambiarTalla(); }

  /* Formulario de compra: si no hay talla, avisar en vez de añadir la primera. */
  var form = document.querySelector('[data-p-form-compra]');
  if (form && tallas.length) {
    form.addEventListener('submit', function (e) {
      if (!tallaElegida()) {
        e.preventDefault();
        var aviso = document.querySelector('[data-p-aviso-talla]');
        if (aviso) { aviso.hidden = false; }
        var primera = tallas[0];
        if (primera) { primera.focus(); }
      }
    });
  }

  /* Galería: la tira ya cambia sola (scroll-snap y enlaces #p-foto-N). Aquí solo se
     evita el salto de página al tocar una miniatura y se marca la foto que se ve. */
  var tira = document.querySelector('[data-p-tira]');
  var minis = document.querySelectorAll('[data-p-mini]');
  function marcarMini(n) {
    minis.forEach(function (m) { m.setAttribute('aria-current', m.getAttribute('data-p-mini') === String(n) ? 'true' : 'false'); });
  }
  if (tira && minis.length) {
    minis.forEach(function (m) {
      m.addEventListener('click', function (e) {
        var foto = document.getElementById((m.getAttribute('href') || '').slice(1));
        if (!foto) { return; }
        e.preventDefault();
        tira.scrollTo({ left: foto.offsetLeft, behavior: 'smooth' });
        marcarMini(m.getAttribute('data-p-mini'));
      });
    });
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (en.isIntersecting) { marcarMini(en.target.getAttribute('data-p-foto')); } });
      }, { root: tira, threshold: 0.6 });
      tira.querySelectorAll('[data-p-foto]').forEach(function (li) { io.observe(li); });
    }
  }

  /* La hora de ahora. En un tema sin publicar, ?p_ahora=2026-12-17T13:01 (hora de Madrid)
     hace como si fuera esa hora, para ver cómo queda cada fecha fuerte y la fecha de entrega
     de ese día sin esperar a que llegue (f18, 14 oct 2026). En la tienda publicada no hace
     nada: el cliente ve siempre la hora de verdad. */
  var ahora = (function () {
    var m = /[?&]p_ahora=(\d{4})-(\d\d)-(\d\d)T(\d\d):(\d\d)/.exec(location.search);
    var tema = window.Shopify && window.Shopify.theme;
    if (!m || !tema || tema.role === 'main' || !window.Intl) { return function () { return new Date(); }; }
    var fijo = null;
    [60, 120].some(function (desfase) {
      var t = new Date(Date.UTC(+m[1], +m[2] - 1, +m[3], +m[4], +m[5]) - desfase * 60000);
      var p = {};
      new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Madrid', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' })
        .formatToParts(t).forEach(function (x) { p[x.type] = x.value; });
      if (+p.hour === +m[4] && +p.minute === +m[5]) { fijo = t; return true; }
      return false;
    });
    if (!fijo) { return function () { return new Date(); }; }
    var empieza = Date.now();
    return function () { return new Date(fijo.getTime() + (Date.now() - empieza)); };
  })();

  /* Entrega (7 oct 2026). La fecha la calcula el navegador, no el servidor: Shopify
     guarda la página en caché, y Google, las IAs y las vistas previas se quedaban con
     una fecha que a los dos días era falsa. El HTML trae la regla, que es verdad
     siempre, y aquí se pone la fecha encima: con la hora de Madrid aunque quien mire
     esté en otro huso, y saltando los festivos del ajuste del tema (data-p-festivos
     del body). Regla: de lunes a viernes no festivo, antes de la hora de corte sale
     ese día; si no, el siguiente laborable. Llega dos laborables después de salir.
     Si algo falla, se queda la regla. */
  var entrega = (function () {
    var festivos = document.body.getAttribute('data-p-festivos') || '';
    var DIAS = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];
    var MESES = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto',
      'septiembre', 'octubre', 'noviembre', 'diciembre'];
    var iso = function (d) { return d.toISOString().slice(0, 10); };
    var laborable = function (d) {
      var w = d.getUTCDay();
      return w > 0 && w < 6 && festivos.indexOf(',' + iso(d) + ',') < 0;
    };
    var luego = function (d) { return new Date(d.getTime() + 86400000); };
    var madrid = function (cuando) {
      var p = {};
      new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Madrid', year: 'numeric', month: '2-digit',
        day: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' })
        .formatToParts(cuando || new Date()).forEach(function (x) { p[x.type] = x.value; });
      return { dia: new Date(Date.UTC(+p.year, +p.month - 1, +p.day)), min: (+p.hour % 24) * 60 + (+p.minute) };
    };
    var calcula = function (corte, cuando) {
      var m = madrid(cuando), sale = m.dia, hoy = laborable(sale) && m.min < corte * 60;
      if (!hoy) { do { sale = luego(sale); } while (!laborable(sale)); }
      var llega = sale, n = 0;
      while (n < 2) { llega = luego(llega); if (laborable(llega)) { n++; } }
      return { hoy: hoy, sale: sale, llega: llega, restan: corte * 60 - m.min };
    };
    var larga = function (d) { return DIAS[d.getUTCDay()] + ' ' + d.getUTCDate() + ' de ' + MESES[d.getUTCMonth()]; };
    var corta = function (d) { return DIAS[d.getUTCDay()] + ' ' + d.getUTCDate(); };
    return { calcula: calcula, larga: larga, corta: corta };
  })();

  /* Los huecos que deja pandilla-entrega.liquid (y la franja de arriba). Todos a la vez:
     la cesta y la ficha pueden enseñar dos. Cada 30 s, por si pasa la hora de corte. */
  var huecos = [].slice.call(document.querySelectorAll('[data-p-llega],[data-p-sale],[data-p-fecha],[data-p-aviso]'));
  if (huecos.length && window.Intl) {
    var corteDe = function (el, attr) { return parseInt(el.getAttribute(attr), 10) || 13; };
    var pintarEntregas = function () {
      try {
        huecos.forEach(function (el) {
          var c, r, f;
          if (el.hasAttribute('data-p-llega')) {
            r = entrega.calcula(corteDe(el, 'data-p-llega'), ahora());
            el.textContent = 'Lo tienes el ' + entrega.larga(r.llega);
          } else if (el.hasAttribute('data-p-sale')) {
            c = corteDe(el, 'data-p-sale');
            r = entrega.calcula(c, ahora());
            /* 14 oct 2026 (f19): la cuenta atrás apunta a la fecha de llegada que está
               justo encima, no a la salida del taller, y no nombra la hora de corte
               salvo de madrugada, cuando faltan más de 12 h. */
            if (r.hoy && r.restan <= 12 * 60) {
              var h = Math.floor(r.restan / 60), m = r.restan % 60;
              el.innerHTML = 'Si lo pides en las próximas <b>' + (h ? h + ' h ' : '') + m + ' min</b>';
            } else if (r.hoy) {
              el.textContent = 'Si lo pides antes de las ' + c + ':00';
            } else {
              el.textContent = 'Si lo pides hoy';
            }
          } else if (el.hasAttribute('data-p-aviso')) {
            r = entrega.calcula(corteDe(el, 'data-p-aviso'), ahora());
            el.textContent = el.getAttribute(r.hoy ? 'data-p-texto' : 'data-p-texto-tarde')
              .replace('{fecha}', entrega.larga(r.llega));
          } else {
            r = entrega.calcula(corteDe(el, 'data-p-fecha'), ahora());
            f = el.getAttribute('data-p-formato') === 'corta' ? entrega.corta(r.llega) : entrega.larga(r.llega);
            el.textContent = (el.getAttribute('data-p-plantilla') || '{fecha}').replace('{fecha}', f);
          }
        });
      } catch (e) {}
    };
    pintarEntregas();
    setInterval(pintarEntregas, 30000);
  }

  /* Fechas fuertes (f18, 14 oct 2026). Los textos de Navidad, Black Friday y Reyes cambian
     solos a la hora exacta, para que la web diga lo mismo que los anuncios el mismo minuto.
     El calendario viene en <body data-p-fases> («nombre,desde,hasta;», en AAAAMMDDHHMM con
     la hora de Madrid) y cada texto dice en qué fases sale (data-p-en) o en cuáles no
     (data-p-no). El servidor ya pinta la página con la fase de su reloj, pero Shopify la
     guarda en caché: aquí se vuelve a mirar al cargar y cada 30 s. Si dos fases coinciden,
     gana la que empezó más tarde; si empezaron a la vez, la que acaba antes. La fase de
     ahora queda en <body data-p-fase>, para comprobarla desde fuera. */
  var calendario = (document.body.getAttribute('data-p-fases') || '').split(';').map(function (t) {
    var p = t.split(',');
    return { n: p[0], d: +p[1], h: +p[2] };
  }).filter(function (f) { return f.n && f.d && f.h; });
  if (window.Intl) {
    var numMadrid = function (cuando) {
      var p = {};
      new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Madrid', year: 'numeric', month: '2-digit',
        day: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' })
        .formatToParts(cuando).forEach(function (x) { p[x.type] = x.value; });
      return +(p.year + p.month + p.day + ('0' + (+p.hour % 24)).slice(-2) + p.minute);
    };
    var faseDe = function (n) {
      var g = null;
      calendario.forEach(function (f) {
        if (n >= f.d && n < f.h && (!g || f.d > g.d || (f.d === g.d && f.h < g.h))) { g = f; }
      });
      return g ? g.n : 'fuera';
    };
    /* La cuenta atrás hasta el final de una fase (data-p-faltan="corte"): días de calendario
       que quedan hasta el último día, en hora de Madrid. Si la fase acaba a medianoche, su
       último día es el anterior; si acaba a una hora, ese día se dice la hora. Pasada la fase,
       se vacía y el CSS la esconde. «Faltan» y no «quedan»: en la ficha, justo encima, va
       «te quedan 3 h» de la salida de hoy, y las dos cuentas no deben sonar igual. */
    var faltan = function (n) {
      [].forEach.call(document.querySelectorAll('[data-p-faltan]'), function (el) {
        var f = null, txt = '';
        calendario.forEach(function (c) { if (c.n === el.getAttribute('data-p-faltan')) { f = c; } });
        if (f && n < f.h) {
          var dia = function (x) { var s = String(x); return Date.UTC(+s.slice(0, 4), +s.slice(4, 6) - 1, +s.slice(6, 8)); };
          var hhmm = f.h % 10000, ultimo = dia(f.h) - (hhmm ? 0 : 86400000);
          var d = Math.round((ultimo - dia(n)) / 86400000);
          if (d <= 0) {
            txt = hhmm ? 'Último día: hasta las ' + Math.floor(hhmm / 100) + ':' + ('0' + hhmm % 100).slice(-2) : 'Último día';
          } else {
            txt = d === 1 ? 'Falta 1 día' : 'Faltan ' + d + ' días';
          }
        }
        if (el.textContent !== txt) { el.textContent = txt; }
      });
    };
    var pintarFases = function () {
      try {
        var n = numMadrid(ahora());
        faltan(n);
        var f = faseDe(n), k = ' ' + f + ' ';
        if (document.body.getAttribute('data-p-fase') !== f) { document.body.setAttribute('data-p-fase', f); }
        [].forEach.call(document.querySelectorAll('[data-p-en],[data-p-no]'), function (el) {
          var en = el.getAttribute('data-p-en'), no = el.getAttribute('data-p-no');
          var ver = (en === null || (' ' + en + ' ').indexOf(k) >= 0) &&
            (no === null || (' ' + no + ' ').indexOf(k) < 0);
          if (el.hidden === ver) { el.hidden = !ver; }
        });
      } catch (e) {}
    };
    pintarFases();
    setInterval(pintarFases, 30000);
  }

  /* Preferencias de cookies, al pie (f18, 14 oct 2026). Retirar el consentimiento tiene que ser
     tan fácil como darlo: el botón vuelve a abrir el aviso de Shopify. Sale solo cuando el aviso
     está en la página (window.privacyBanner, que Shopify carga un poco después). */
  var botonCookies = document.querySelector('[data-p-cookies]');
  if (botonCookies) {
    var hayAviso = function () {
      return !!(window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function');
    };
    var intentos = 0;
    var mirarAviso = function () {
      if (hayAviso()) { botonCookies.hidden = false; return; }
      if (++intentos < 20) { setTimeout(mirarAviso, 500); }
    };
    mirarAviso();
    botonCookies.addEventListener('click', function () {
      if (hayAviso()) { window.privacyBanner.showPreferences(); }
    });
  }

  /* Buscador de la cabecera: se cierra con Escape y al tocar fuera. */
  var buscador = document.getElementById('p-buscador');
  if (buscador) {
    buscador.addEventListener('toggle', function () {
      if (buscador.open) {
        var campo = buscador.querySelector('input[type="search"]');
        if (campo) { campo.focus(); }
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && buscador.open) { buscador.open = false; buscador.querySelector('summary').focus(); }
    });
    document.addEventListener('click', function (e) {
      if (buscador.open && !buscador.contains(e.target)) { buscador.open = false; }
    });
  }

  /* Desplegables sueltos (<details data-p-desplegable>, como las políticas del
     pie): sin JS abren y cierran igual; esto solo añade Escape y clic fuera. */
  var desplegables = document.querySelectorAll('details[data-p-desplegable]');
  if (desplegables.length) {
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') { return; }
      desplegables.forEach(function (d) {
        if (d.open) { d.open = false; d.querySelector('summary').focus(); }
      });
    });
    document.addEventListener('click', function (e) {
      desplegables.forEach(function (d) {
        if (d.open && !d.contains(e.target)) { d.open = false; }
      });
    });
  }

  /* Cantidad: los botones +/− tocan el número; el formulario decide. */
  document.querySelectorAll('[data-p-cantidad]').forEach(function (c) {
    var input = c.querySelector('input');
    c.querySelectorAll('button').forEach(function (b) {
      b.addEventListener('click', function () {
        var n = parseInt(input.value || '1', 10);
        n = b.getAttribute('data-p-mas') !== null ? n + 1 : Math.max(parseInt(input.min || '1', 10), n - 1);
        input.value = n;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  /* Cesta: cambiar la cantidad envía el formulario solo. */
  document.querySelectorAll('[data-p-cesta-form] input[name="updates[]"]').forEach(function (i) {
    i.addEventListener('change', function () { i.form.requestSubmit ? i.form.requestSubmit() : i.form.submit(); });
  });

  /* Recomendaciones: se piden a Shopify y se pintan donde toca. */
  var reco = document.querySelector('[data-p-recomendaciones]');
  if (reco) {
    var url = reco.getAttribute('data-p-url');
    fetch(url).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var dentro = doc.querySelector('[data-p-recomendaciones]');
      if (dentro && dentro.innerHTML.trim()) { reco.innerHTML = dentro.innerHTML; reco.hidden = false; }
    }).catch(function () {});
  }
  /* Vídeos en pantallas de gama amplia (8 oct 2026). En Windows, Chrome y Edge mandan a veces
     el vídeo directo a la tarjeta gráfica sin pasarlo por la gestión de color, y en una pantalla
     P3 o HDR sale sobresaturado mientras las fotos se ven bien. Un lienzo sí pasa por la gestión
     de color, como las fotos: se pinta encima cada fotograma del vídeo. En pantallas normales no
     se toca nada. ?lienzo=1 lo fuerza y ?lienzo=0 lo quita, para comparar. */
  var q = location.search;
  var amplia = window.matchMedia && (matchMedia('(color-gamut: p3)').matches || matchMedia('(dynamic-range: high)').matches);
  if (!/[?&]lienzo=0/.test(q) && (amplia || /[?&]lienzo=1/.test(q))) {
    [].forEach.call(document.querySelectorAll('video[data-p-video]'), function (v) {
      var c = document.createElement('canvas');
      c.className = 'p-video-lienzo'; c.setAttribute('aria-hidden', 'true');
      c.width = +v.getAttribute('width') || 720; c.height = +v.getAttribute('height') || 900;
      var ctx = c.getContext('2d', { colorSpace: 'srgb' }) || c.getContext('2d');
      if (!ctx) return;
      v.parentNode.insertBefore(c, v.nextSibling);
      var sigue;
      var pinta = function () { if (v.readyState >= 2) ctx.drawImage(v, 0, 0, c.width, c.height); sigue(); };
      sigue = v.requestVideoFrameCallback
        ? function () { v.requestVideoFrameCallback(pinta); }
        : function () { requestAnimationFrame(pinta); };
      sigue();
    });
  }
})();
